import { LegacySpinner } from '@/ui/LegacySpinner';
import { useLoaderStore } from './loader-store';

/**
 * Full-viewport modal overlay shown while {@link useLoaderStore} `show` is true.
 * Rendered once at the shell root (ShellLayout); MFEs and async flows trigger
 * it via `displayLoader()` / `hideLoader()` (or the legacy globals once the
 * M2.9 shim is installed).
 */
export function LoaderOverlay() {
  const show = useLoaderStore((s) => s.show);
  const message = useLoaderStore((s) => s.message);

  if (!show) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '1rem',
        background: 'rgba(255, 255, 255, 0.6)',
        backdropFilter: 'blur(2px)',
      }}
    >
      <LegacySpinner message={message} />
    </div>
  );
}
